<template>
  <el-scrollbar class="el-scroll_run">
    <div class="edit-per-run" :class="{ 'default-run': isDefault }">
      <div class="edit-buy-wrapper">
        <div class="edit-buy">
          <div class="per-run-item posterStyle">
            <div class="per-run-item-title personal-vip-title">
              <span>导购链接</span>
              <i class="vip">VIP</i>
            </div>
            <div class="right">
              <el-select class="per-run-item-select" v-model="shop" size="mini" @change="changeBuyLink(shop, 'buyLink')">
                <el-option v-for="item in shoopOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
              <div class="set" @click="showOpen" v-if="this.shop == 1">
                设置
              </div>
            </div>
          </div>
          <div class="per-run-item posterStyle" v-if="paperStyle && shop == 1">
            <div class="per-run-item-title">
              <span>pc端导购名称</span>
            </div>
            <div class="right-name">
              <el-input v-model="pcBuyLinkName" size="mini"></el-input>
            </div>
          </div>
          <div class="per-run-item posterStyle" v-if="this.shop == 1">
            <div class="per-run-item-title">
              <span class="title">导购图标</span>
            </div>
            <div class="right">
              <el-select class="edit-questionaire-item-select" v-model="buyIconType" size="mini" @change="iconSelectChange">
                <el-option v-for="item in iconSelectOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
              <div class="uploadlogo" v-if="buyIconType === -1">
                <div class="upload">
                  <el-select class="personal-item-select pic-list" size="mini" v-model="buyIcon">
                    <el-option class="pic-list-item question-icon" v-for="(item, index) in uploadIconList" :key="'shopPic' + index" :label="item.name" :value="item.path">
                      {{ item.name }}
                      <img class="select-del" src="@imgs/delete-gray.png" @click="delIcon(item, $event)" />
                    </el-option>
                  </el-select>
                  <label class="uploadlogoButton" for="shopPicButton">上传</label>
                  <input
                    type="file"
                    id="shopPicButton"
                    ref="shopPic"
                    value="imgFile"
                    accept="image/png, image/jpg, image/jpeg, image/gif"
                    @change="uploadShopImg($event, 'shoppingGuideLinkIcon')"
                    style="display: none"
                  />
                </div>
                <div v-if="buyIcon && buyIcon.length > 2" class="thumbnail"><img :src="buyIcon" alt="" /></div>
                <div class="thumbnail upload-tip" v-else>
                  <p>建议尺寸80*80</p>
                  <p>显示效果最佳</p>
                </div>
              </div>
            </div>
          </div>
          <div class="per-run-item posterStyle" v-if="shop === 1 && buyIconType >= 20">
            <div class="per-run-item-title">
              <span class="title">文字内容</span>
            </div>
            <div class="right">
              <el-input style="width: 135px" v-model="buyIcon" placeholder="请输入" @change="checkWord" maxlength="12" size="mini"></el-input>
              <div class="warning-text" v-if="showWarning">请输入1-6个汉字</div>
            </div>
          </div>
          <div class="per-run-item posterStyle" v-if="shop === 1 && buyIconType >= 20">
            <div class="per-run-item-title">
              <span class="title">文字样式</span>
            </div>
            <div class="right">
              <el-select class="personal-item-select pic-list" size="mini" v-model="textIconStyle">
                <el-option class="pic-list-item question-icon" v-for="(item, index) in textIconStyleOptions" :key="'shopText' + index" :label="item.label" :value="item.value">
                  {{ item.label }}
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
        <edit-charge v-if="!isPaper"></edit-charge>
      </div>
      <div class="per-run-item">
        <EditQuestionaire ref="editQuestionaire" type="book"></EditQuestionaire>
      </div>
      <el-dialog center width="650px" top="calc( 50vh - 150px )" :visible.sync="open" :modal-append-to-body="false">
        <div slot="title" class="header-title" :style="{ background: '#f4f4f4' }">
          <div style=" font-size: 16px; font-weight: bold;">设置导购链接</div>
        </div>
        <div class="setting" style="display: flex;">
          <div id="1" class="set-item" style="color: #fff">
            0
          </div>

          <div class="set-item-input_" style="height: 30px!important; font-size: 14px;color: #515151">导购链接名称：</div>
          <div class="set-item-input" style="height: 30px!important; font-size: 14px;color: #515151">点击购物车按钮跳转地址：</div>
        </div>
        <div class="setting" style="display: flex;margin-top: 10px;">
          <div id="2" class="set-item">
            1
          </div>
          <el-input maxlength="10" v-model="link1.name" class="set-item-input_" style="height: 30px!important;"></el-input>
          <el-input v-model="link1.link" class="set-item-input" style="height: 30px!important;"></el-input>
        </div>

        <div class="setting" style="display: flex;">
          <div id="3" class="set-item">
            2
          </div>
          <el-input maxlength="10" v-model="link2.name" class="set-item-input_" style="height: 30px!important;"></el-input>
          <el-input v-model="link2.link" class="set-item-input" style="height: 30px!important;"></el-input>
        </div>

        <div class="setting" style="display: flex;">
          <div id="4" class="set-item">
            3
          </div>
          <el-input maxlength="10" v-model="link3.name" class="set-item-input_" style="height: 30px!important;"></el-input>
          <el-input v-model="link3.link" class="set-item-input" style="height: 30px!important;"></el-input>
        </div>

        <div class="setting" style="display: flex;">
          <div id="5" class="set-item">
            4
          </div>
          <el-input maxlength="10" v-model="link4.name" class="set-item-input_" style="height: 30px!important;"></el-input>
          <el-input v-model="link4.link" class="set-item-input" style="height: 30px!important;"></el-input>
        </div>
        <div class="setting" style="display: flex;">
          <div id="6" class="set-item">
            5
          </div>
          <el-input maxlength="10" v-model="link5.name" class="set-item-input_" style="height: 30px!important;"></el-input>
          <el-input v-model="link5.link" class="set-item-input" style="height: 30px!important;"></el-input>
        </div>

        <div class="set-button">
          <div class="but1" @click="open = false">
            取消
          </div>
          <div class="but2" @click="sendSet">
            确定
          </div>
        </div>
      </el-dialog>
      <tip-dialog ref="memberDialog" :dialogOptions="memberDialogOptions"></tip-dialog>
      <TipDialog ref="deleteDialog" :dialogOptions="deleteDialogOptions" @clickCancel="deleteCancel" @clickConfirm="deleteConfirm" :appendToBody="true"></TipDialog>
    </div>
  </el-scrollbar>
</template>

<script>
import EditQuestionaire from '@components/commonEdit/editQuestionaire'
import TipDialog from '@components/common/TipDialog.vue'
import compareVipRight from '@components/common/compareVipRight.js'
import setBook from '@api/setBook'
import { uploadIconPic, getStrByteCount } from '@/utils'
import EditCharge from './EditCharge'
export default {
  data() {
    return {
      open: false,
      buyLink: [],
      link1: {
        name: '',
        link: ''
      },
      link2: {
        name: '',
        link: ''
      },
      link3: {
        name: '',
        link: ''
      },
      link4: {
        name: '',
        link: ''
      },
      link5: {
        name: '',
        link: ''
      },
      shoopOptions: [
        {
          value: 0,
          label: '关闭'
        },
        {
          value: 1,
          label: '开启'
        }
      ],
      isUpload: false,
      uploadIconList: [],
      uploadChargeIconList: [],
      iconSelectOptions: [
        {
          value: 1,
          label: '购买纸书'
        },
        {
          value: 2,
          label: '购买纸刊'
        },
        {
          value: 6,
          label: '订阅纸刊'
        },
        {
          value: 3,
          label: '购买纸报'
        },
        {
          value: 7,
          label: '订阅纸报'
        },
        {
          value: 4,
          label: '购买商品'
        },
        {
          value: 5,
          label: '前往店铺'
        },
        {
          value: -1,
          label: '自定义图片图标'
        },
        {
          value: 20,
          label: '自定义文字图标'
        }
      ],
      textIconStyleOptions: [
        {
          value: 20,
          label: '样式一'
        },
        {
          value: 21,
          label: '样式二'
        }
      ],
      showWarning: false,
      deletePic: null,
      deleteDialogOptions: {
        // 弹框类型
        type: 'delete',
        // 弹框头部标题
        title: '提示',
        // 弹框内容
        tip: '是否确认删除？'
      }
    }
  },
  props: {
    isDefault: {
      type: Boolean,
      default: false
    },
    isPaper: {
      type: Boolean,
      default: false
    }
  },
  mixins: [compareVipRight],
  computed: {
    shop: {
      get: function() {
        return this.$store.state.config.bookObj.shop
      },
      set: function(value) {
        this.$store.commit('config/SHOP', value)
      }
    },
    buyIcon: {
      get: function() {
        return this.$store.state.config.bookObj.buyIcon
      },
      set: function(value) {
        this.$store.commit('config/BUY_ICON', value)
      }
    },
    buyIconType: {
      get: function() {
        return this.$store.state.config.bookObj.buyIconType > 20 ? 20 : this.$store.state.config.bookObj.buyIconType
      },
      set: function(value) {
        this.$store.commit('config/BUY_ICON_TYPE', value)
      }
    },
    textIconStyle: {
      get: function() {
        return this.$store.state.config.bookObj.buyIconType
      },
      set: function(value) {
        this.$store.commit('config/BUY_ICON_TYPE', value)
      }
    },
    chargeIconType: {
      get: function() {
        return this.$store.state.config.bookObj.chargeIconType
      },
      set: function(value) {
        this.$store.commit('config/CHARGE_ICON_TYPE', value)
      }
    },
    charge: {
      get: function() {
        return this.$store.state.config.bookObj.charge
      },
      set: function(value) {
        this.$store.commit('config/CHARGE', value)
      }
    },
    chargeIcon: {
      get: function() {
        return this.$store.state.config.bookObj.chargeIcon
      },
      set: function(value) {
        this.$store.commit('config/CHARGE_ICON', value)
      }
    },
    pcBuyLinkName: {
      get: function() {
        return this.$store.state.config.bookObj.pcBuyLinkName || '导购'
      },
      set: function(value) {
        this.$store.commit('config/PCBUY_LINKNAME', value)
      }
    },
    showLink() {
      return this.$store.state.config.bookObj.buyLink
    },
    memberDialogOptions() {
      return {
        // 弹框类型
        type: 'member',
        // 弹框头部标题
        title: '提示',
        // 弹框内容
        tip: `您当前为${this.$store.state.common.vipRight.name}，使用此功能需先升级会员服务！`
      }
    },
    paperStyle() {
      return this.$store.state.config.paperStyle
    }
  },
  methods: {
    async showOpen() {
      if (!(await this.compareRight({ type: 'boole', key: 'buyLink' }))) {
        this.$refs.memberDialog.visible = true
        return
      }

      this.open = true
      if (this.showLink !== '') {
        let Link = JSON.parse(this.showLink)
        if (Link.a.name !== undefined) {
          this.link1 = Link.a
        }
        if (Link.b.name !== undefined) {
          this.link2 = Link.b
        }
        if (Link.c.name !== undefined) {
          this.link3 = Link.c
        }
        if (Link.d.name !== undefined) {
          this.link4 = Link.d
        }
        if (Link.e.name !== undefined) {
          this.link5 = Link.e
        }
      }
    },
    sendSet() {
      let buyLink = { a: {}, b: {}, c: {}, d: {}, e: {} }
      if (this.link1.name !== '') {
        buyLink.a = this.link1
      }
      if (this.link2.name !== '') {
        buyLink.b = this.link2
      }
      if (this.link3.name !== '') {
        buyLink.c = this.link3
      }
      if (this.link4.name !== '') {
        buyLink.d = this.link4
      }
      if (this.link5.name !== '') {
        buyLink.e = this.link5
      }

      this.$store.commit('config/BUY_LINK', JSON.stringify(buyLink))
      this.$emit('saveRunThen', 'curPage')
      this.open = false
    },
    async changeBuyLink(value, type) {
      if (value === 1) {
        this.$store.commit('config/PCBUY_LINKNAME', this.pcBuyLinkName)
        if (!(await this.compareRight({ type: 'boole', key: type }))) {
          this.$refs.memberDialog.visible = true
          this.$nextTick(() => {
            if (type === 'charge') {
              this.charge = 0
            } else {
              this.$store.commit('config/SHOP', 0)
            }
          })
          return
        }
      }
    },
    check() {
      this.$emit('checkcallback', this.$refs.editQuestionaire.check())
    },
    checkWord(value) {
      let strByteCount = getStrByteCount(value)
      this.showWarning = strByteCount > 12 || strByteCount < 1
    },
    getData() {
      const data = {
        questionaireData: this.$refs.editQuestionaire.getData()
      }
      return data
    },
    async iconSelectChange(value) {
      if (value === -1) {
        this.isUpload = true
        this.buyIcon = ''
      } else {
        this.isUpload = false
        if (value < 20) {
          this.buyIcon = value
        } else {
          this.buyIcon = ''
        }
      }
    },
    async getImage(module) {
      await setBook.getImageList({ module: module }).then((res) => {
        if (res.status === 200 && res.data.code === 0) {
          if (module === 'chargeIcon') {
            this.uploadChargeIconList = res.data.data
          } else {
            this.uploadIconList = res.data.data
          }
        } else {
          console.log('获取图片列表失败')
        }
      })
    },
    delIcon(item, e) {
      this.deletePic = item
      this.$refs.deleteDialog.visible = true
    },
    async uploadShopImg(e, type) {
      const result = await uploadIconPic(e, type, 1, this)
      if (result && result.length > 0) {
        this.uploadIconList = result
        this.buyIcon = this.uploadIconList[0].path
      }
    },
    deleteCancel() {
      this.$refs.deleteDialog.visible = false
      this.deletePic = null
    },
    deleteConfirm() {
      let module = this.deletePic.module
      setBook.delImage({ ids: this.deletePic.id }).then((res) => {
        if (res.status === 200 && res.data.code === 0) {
          this.getImage(module)
          this.buyIcon = ''
        } else {
          console.log('删除列表失败')
        }
      })
      this.deletePic = null
      this.$refs.deleteDialog.visible = false
    }
  },
  mounted() {
    this.getImage('shoppingGuideLinkIcon')
  },
  components: {
    EditCharge,
    EditQuestionaire,
    TipDialog
  }
}
</script>

<style lang="scss" scoped>
.setting {
  /deep/ .el-input__inner {
    height: 30px !important;
  }
}
</style>
<style lang="scss">
.el-scroll_run {
  height: 100% !important;
}
.set-button {
  margin-top: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  div {
    width: 109px;
    height: 38px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
  }
  .but1 {
    background-color: #999999;
    margin-right: 10px;
  }
  .but2 {
    margin-left: 10px;
    background-color: #df5813;
  }
}
.setting {
  margin-top: 20px;
  .set-item {
    // color: #a9a9a9;
    line-height: 30px;
    font-size: 14px;
    margin-left: 50px;
  }
  .set-item-input {
    width: 250px;
    margin-left: 30px;
    color: #a9a9a9;
  }
  .set-item-input_ {
    width: 178px;
    margin-left: 30px;
    color: #a9a9a9;
  }
}
.set {
  cursor: pointer;
  width: 60px;
  height: 20px;
  margin-top: 5px;
  background: #df5813;
  border-radius: 10px;
  line-height: 20px;
  text-align: center;
  color: #fff;
}
.edit-per-run {
  user-select: none;
  height: 100%;
  padding-bottom: 20px;
  .edit-buy {
    margin-bottom: 30px;
    .warning-text {
      color: #d33636;
    }
  }
  .per-run-item {
    display: flex;
    align-items: center;
    margin-top: 18px;
    &.flex-start {
      align-items: flex-start;
    }
    .edit-per-run-adorn {
      width: 140px;
      .custom-tip {
        padding: 0px 14px;
        line-height: 17px;
        width: 120px;
      }
    }
    &:first-of-type {
      margin-top: 10px;
    }
    .per-run-item-title {
      display: inline-block;
      margin-right: 10px;
      font-size: 13px;
      width: 115px !important;
      text-align: right;
      white-space: nowrap;
      line-height: 24px;
    }
    .right-name {
      width: 136px;
    }
    .loading-color {
      width: 90px;
      height: 24px;
      .el-color-picker {
        width: 100%;
        height: 100%;
        .el-color-picker__trigger {
          width: 100%;
          height: 100%;
          padding: 0;
          border: 1px solid #cecece !important;
          .el-color-picker__icon {
            text-align: right;
            padding-right: 10px;
            &.el-icon-arrow-down::before {
              color: #fff;
            }
          }
        }
      }
    }
    .per-run-item-select {
      &.el-select {
        width: 90px;
        .el-input {
          .el-input__inner {
            border-color: #cecece;
            height: 24px;
            font-size: 13px;
            padding: 0 5px;
            line-height: 24px;
          }
        }
      }
      .el-icon-arrow-up::before {
        color: #515151;
      }
    }
    &.loadingText {
      .el-input {
        width: 90px;
        .el-input__inner {
          height: 24px;
          padding: 0 5px;
          font-size: 14px;
        }
      }
    }
    &.price {
      .el-input {
        margin-right: 5px;
        .el-input__inner {
          height: 24px;
          width: 52px;
          padding: 0 5px;
          font-size: 14px;
          text-align: center;
        }
      }
    }
    .per-run-item-content {
      display: inline-flex;
    }
    .required {
      color: red;
    }
    .el-form-item {
      margin-bottom: 0;
      .el-form-item__content {
        margin-left: 0 !important;
        line-height: 24px !important;
        .el-form-item__error {
          white-space: nowrap;
        }
      }
    }
    .uploadlogo {
      margin-top: 10px;
      .uploadlogoButton {
        width: 55px;
        height: 24px;
        background: #df5813;
        color: #fff;
        border-radius: 15px;
        font-size: 14px;
        display: inline-flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        margin: 10px 0 0 8px;
        cursor: pointer;
      }
      .thumbnail {
        width: 120px;
        height: 35px;
        background: #fffaf4;
        color: #515151;
        margin-top: 5px;
        p {
          width: 100%;
          text-align: center;
          font-size: 14px;
          margin: 0;
          line-height: 17px;
        }
        img {
          height: 100%;
        }
      }
      .logoUrlTxt {
        margin: 5px 0;
        font-size: 14px;
      }
    }
  }
  .poster {
    .right {
      .el-select {
        width: 136px !important;
      }
    }
  }
  .posterStyle {
    align-items: flex-start;
    .right {
      .el-select {
        width: 136px !important;
      }
      .customSec {
        margin-top: 6px;
        height: 26px;
        display: flex;
        line-height: 26px;
        justify-content: space-between;
        button {
          width: 60px;
          cursor: pointer;
          background: #df5813;
          border: none;
          color: #fff;
        }
        .customTit {
          width: 70px;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .uploadAudioBut {
          width: 26px;
          height: 26px;
          border: 1px solid #dcdfe6;
          display: -webkit-flex;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          img {
            width: 10px;
          }
        }
        .audio-name {
          width: 103px;
          color: #515151;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
  .loadPic {
    overflow: hidden;
    align-items: flex-start;
    .loadingSelect {
      display: flex;
      align-items: center;
      height: 24px;
      margin-bottom: 5px;
    }
    .uploading {
      height: 100%;
      background: #df5813;
      color: #fff;
      border-radius: 15px;
      border: none;
      width: 55px;
      margin-left: 8px;
      text-align: center;
    }
    .thumbnail {
      width: 120px;
      height: 35px;
      background: rgba(0, 0, 0, 0.6);
      color: #fff;
      p {
        width: 100%;
        text-align: center;
        font-size: 14px;
        margin: 0;
        line-height: 17px;
      }
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .inputTime {
    width: 124px;
  }
  .openDownload {
    align-items: flex-start;
    .right {
      .el-select {
        width: 136px !important;
      }
    }
    .downloadSel {
      padding-top: 10px;
      display: -webkit-flex;
      display: flex;
      justify-content: space-between;
      .species {
        display: -webkit-flex;
        display: flex;
        > span {
          font-size: 12px;
          margin-left: 3px;
          line-height: 14px;
        }
      }
    }
  }
  .personal-vip-title {
    height: 24px;
    span {
      height: 100%;
      line-height: 24px;
    }
    img {
      height: 24px;
      float: right;
      margin-left: 1px;
    }
    i {
      width: 30px;
      line-height: 20px;
      background: #df5813;
      text-align: center;
      color: #fff;
      font-size: 10px;
      margin-left: 5px;
      border-radius: 2px;
      font-style: normal;
      font-weight: bold;
    }
  }
}
.default-run {
  display: flex;
  flex-direction: row;
  padding-bottom: 20px;
  .edit-buy-wrapper {
    width: 50%;
  }
  .edit-buy {
    margin: 0;
    &:first-of-type {
      margin-top: 0;
    }
  }
  .per-run-item {
    align-items: flex-start;
  }
  .edit-questionaire-item-title {
    font-size: 13px;
  }
}
</style>
